module.exports = __webpack_public_path__ + "img/parter-work6.44442521.png";